import type { EditJobAlertsJson } from "@/lib/api-clients/candidate-api-client";

export type NotifyFrequency = EditJobAlertsJson["notifyFrequency"];

export const NOTIFY_FREQUENCY: { [K in NotifyFrequency]: K } = {
  daily: "daily",
  weekly: "weekly",
  off: "off",
};

export type ActiveFrequency = Exclude<
  NotifyFrequency,
  typeof NOTIFY_FREQUENCY.off
>;

export const isNotifyFrequency = (value: string): value is NotifyFrequency =>
  value === NOTIFY_FREQUENCY.daily ||
  value === NOTIFY_FREQUENCY.weekly ||
  value === NOTIFY_FREQUENCY.off;

export const isActiveFrequency = (value: string): value is ActiveFrequency =>
  value === NOTIFY_FREQUENCY.daily || value === NOTIFY_FREQUENCY.weekly;

export const DEFAULT_ACTIVE_FREQUENCY: ActiveFrequency = NOTIFY_FREQUENCY.daily;

export const frequencyForToggle = (
  checked: boolean,
  current: NotifyFrequency,
): NotifyFrequency => {
  if (!checked) return NOTIFY_FREQUENCY.off;
  if (isActiveFrequency(current)) return current;
  return DEFAULT_ACTIVE_FREQUENCY;
};
